module.exports = __webpack_public_path__ + "static/media/Snappy-full-body.8af24888.png";